import { Resume } from '@rio/types'
import { SettingsFieldChangeHandler } from 'builder/modules/resumeEditor'
import { TooltipV2 } from 'builder/components/Tooltip'
import { useI18n } from 'builder/hooks/useI18n'
import { useLayoutAlignmentCustomisation } from '../../hooks/useLayoutAlignmentCustomisation'
import { Icons } from './assets'
import { SelectGroup, SelectControl, Label, FlexBox, ClickableOverlay } from './styles'

const STYLES = {
  SelectGroup,
  SelectControl,
  Label,
  FlexBox,
}

type Props = {
  resume: Resume
  onFieldChange?: SettingsFieldChangeHandler
  styles?: typeof STYLES
}

const TRANSLATION = 'builder.resume_editor.document_customization.sidebar.layout_tab'

export const HeaderAlignmentSelection = (props: Props) => {
  const { i18n } = useI18n()
  const { value, onSelect, isDisabled } = useLayoutAlignmentCustomisation(
    'headerAlignment',
    props.resume,
    props.onFieldChange,
  )
  const Styles = props.styles || STYLES

  return (
    <TooltipV2
      value={i18n.t(`${TRANSLATION}.header_alignment_warning`)}
      width={250}
      multiline={true}
      position="bottom"
      isActive={isDisabled}
    >
      <Styles.SelectGroup>
        <Styles.SelectControl
          position="left"
          label={
            <Label htmlFor="header-alignment-left">{i18n.t(`${TRANSLATION}.left_alignment`)}</Label>
          }
        >
          <input
            type="radio"
            value="left"
            name="headerAlignment"
            id="header-alignment-left"
            checked={value === 'left' && !isDisabled}
            disabled={isDisabled}
            onChange={onSelect}
          />
          <Styles.FlexBox as="label" htmlFor="header-alignment-left" justifyContent="flex-start">
            <ClickableOverlay />
            <Icons.LeftAlignment />
          </Styles.FlexBox>
        </Styles.SelectControl>

        <Styles.SelectControl
          position="center"
          label={
            <Label htmlFor="header-alignment-center">
              {i18n.t(`${TRANSLATION}.center_alignment`)}
            </Label>
          }
        >
          <input
            type="radio"
            value="center"
            name="headerAlignment"
            id="header-alignment-center"
            checked={value === 'center' && !isDisabled}
            disabled={isDisabled}
            onChange={onSelect}
          />
          <Styles.FlexBox as="label" htmlFor="header-alignment-center">
            <ClickableOverlay />
            <Icons.CenterAlignment width="100%" />
          </Styles.FlexBox>
        </Styles.SelectControl>

        <Styles.SelectControl
          position="right"
          label={
            <Label htmlFor="header-alignment-right">
              {i18n.t(`${TRANSLATION}.right_alignment`)}
            </Label>
          }
        >
          <input
            type="radio"
            value="right"
            name="headerAlignment"
            id="header-alignment-right"
            checked={value === 'right' && !isDisabled}
            disabled={isDisabled}
            onChange={onSelect}
          />
          <Styles.FlexBox as="label" htmlFor="header-alignment-right" justifyContent="flex-end">
            <ClickableOverlay />
            <Icons.RightAlignment />
          </Styles.FlexBox>
        </Styles.SelectControl>
      </Styles.SelectGroup>
    </TooltipV2>
  )
}
